import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";

import api from "services/api";

import { DEPRECATED_TEMPLATES, ICategory, ITemplate, IWorkspace } from "./types";
import { ActivitySetupTemplate } from "./ActivitySetupTemplate";
import { Select, TextField } from "v2/components";
import { FormControl, InputAdornment, MenuItem } from "@mui/material";
import { Layout, LayoutTitle, Subheader, Title, Typography, Chip, StyledInputLabel, StyledSelect, StyledTextField } from "./styled";
import SearchIcon from "@mui/icons-material/Search";

interface IProps {
  workspace: IWorkspace;
  categories: ICategory[];
  handleUpdateTemplate: (payload: ITemplate) => void;
  allowedLayouts: {title: string, id: string}[];
}

/**
 * 1. Componente do template (Movi)
 *      - Lista as atividades, etc.
 * 2. Componente da atividade atual sendo editada (receber os dados para mostrar na tela, sla)
 *      - Quando mudo para uma outra activity, não gostaria de perder o estado
 * 3. Quando clico em salvar, gostaria de salvar o dado de todo o template em uma única vez
 * - Resultado: preciso ter um gerenciamento de estado a nível do componente de template.
 */
export function ActivitySetup({
  workspace,
  categories,
  handleUpdateTemplate,
  allowedLayouts,
}: IProps) {
  /**
   * ActivitySetup recebe os dados da página anterior.
   * Create = Busca de uma api geral
   * Editar = Busca de uma api que pega todos os Templates já configurados
   * ActivitySetup espera a mesma interface para ambos os casos.
   * Ao salvar, além de enviar para uma API que se ja existe vinculo com workspace atualiza, se nao existe cria,
   * Ele também salva nesse estado global anterior.
   */
  const [selectedFilter, setSelectedFilter] = useState("TODOS");
  const [search, setSearch] = useState("");
  const [selectedTemplate, setSelectedTemplate] = useState<null | ITemplate>(
    null
  );

  function handleUnselectTemplate() {
    setSelectedTemplate(null);
  }

  return (
    <>
      {!selectedTemplate && (
        <>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Title>
              Selecione um template para configurar as atividades do contrato
            </Title>
            <Typography>
              Por favor, selecione um dos templates abaixo
            </Typography>
          </div>
          <StyledTextField
            value={search}
            placeholder="Pesquisar"
            label="Atividades"
            onChange={(e) => setSearch(e.target.value.toLowerCase())}
            variant="outlined"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon
                    color="action"
                    style={{ width: "24px", aspectRatio: "1" }}
                  />
                </InputAdornment>
              ),
            }}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "16px",
              marginBottom: "20px",
            }}
          >
            <FormControl style={{ width: "230px" }} >
              <StyledInputLabel id="tipo-activity">Tipo</StyledInputLabel>
              <StyledSelect
                labelId="tipo-activity"
                value={selectedFilter}
                onChange={(e) => setSelectedFilter(e.target.value as string)}
                style={{ height: "55.3px", marginBottom: "2.7px" }}
              >
                {categories.filter(category => category.templates.length > 0).map(category => <MenuItem key={category.name} value={category.name}>{category.name}</MenuItem>)}
                <MenuItem value="TODOS">Todos</MenuItem>
              </StyledSelect>
            </FormControl>
          </div>
          {categories.filter(category => selectedFilter === "TODOS" ? true : category.name === selectedFilter).map((category) => (
            <>
              {category.templates.length > 0 && (
                <>
                  <Subheader>{category.name}</Subheader>
                  <div
                      style={{ display: "flex", flexDirection: "row", gap: "24px" }}
                    >
                    {category.templates.filter(template => !DEPRECATED_TEMPLATES.includes(template.name)).filter(template => !search ? true : template.name.toLowerCase().includes(search)).map((template) => (
                      <Layout onClick={() => setSelectedTemplate(template)}>
                        <LayoutTitle>{template.name}</LayoutTitle>
                        <Chip label={category.shortName} variant="outlined" />
                        {!template.isConfigured ? (
                          <Chip label="Não configurado" variant="filled" style={{ backgroundColor: "#191C1A14" }} />
                        ) : (
                          <Chip label="Ativo" variant="filled" style={{ backgroundColor: "#2E7D3214", color: "#2E7D32" }} />
                        )}
                      </Layout>
                    ))}
                  </div>
                </>
              )}
            </>
          ))}
        </>
      )}
      {selectedTemplate && (
        <ActivitySetupTemplate
          workspace={workspace}
          template={selectedTemplate}
          allowedLayouts={allowedLayouts}
          handleUpdateTemplate={handleUpdateTemplate}
          handleUnselectTemplate={handleUnselectTemplate}
        />
      )}
    </>
  );
}
